import { inject, Injectable } from '@angular/core';
import { SiaAIFilesApi } from '../apis/ai-files.api';
import { SiaGridFilterRequest } from '../interfaces/ai-filters';
import { SiaAIFiltersKeys } from '../interfaces/ai-filters-keys';
import { SiaGridFile } from '../interfaces/grid-file';

@Injectable({
  providedIn: 'root',
})
export class SiaAIFilesService {
  #api = inject(SiaAIFilesApi);

  retriveFiles(
    queryText: string | null | undefined,
    startIndex: number | undefined,
    endIndex: number | undefined,
    loadRelevantFiles: boolean | undefined,
    filesSha256ToExclude: string[] | undefined,
    categories: string[] | undefined,
    filters: SiaGridFilterRequest[] | undefined,
  ): Promise<{
    files: SiaGridFile[];
    totalCount: number;
    smartFilters: SiaGridFilterRequest[] | null;
    smartFiltersCategories: string[] | null;
  }> {
    return this.#api.retriveFiles(
      queryText,
      startIndex,
      endIndex,
      loadRelevantFiles,
      filesSha256ToExclude,
      categories,
      filters,
    );
  }

  retrieveFileProperties(sha256: string): Promise<any> {
    return this.#api.retrieveFileProperties(sha256);
  }


  retriveKeysFilterChips(categories: Set<string>): Promise<SiaAIFiltersKeys[]> {
    return this.#api.retriveKeysFilterChips(categories);
  }
}
